/**
 * Detect fn
 */
export default () => 'includes' in Array.prototype
